'use strict';

import VoteOptionCollection from 'standard-vote/app/scripts/collections/vote-option.js';

module.exports = VoteOptionCollection;



// WEBPACK FOOTER //
// ./app/scripts/collections/vote-option.js